import PropTypes from 'prop-types';
import React from 'react';

const CartPromoBadge = ({ title, text1, text2 }) => {
  if (!text1 && !text2) return null;
  return (
    <div className='dln-cart-promo-badge'>
      {title && <div className='dln-cart-promo-badge__title'>{title}</div>}
      <div className='dln-cart-promo-badge__badge'>
        {text1 && <span dangerouslySetInnerHTML={{ __html: text1 }} />}
        {text1 && text2 && (
          <>
            <br />
            <br />
          </>
        )}
        {text2 && <span dangerouslySetInnerHTML={{ __html: text2 }} />}
        <span />
      </div>
    </div>
  );
};

CartPromoBadge.propTypes = {
  title: PropTypes.string,
  text1: PropTypes.string,
  text2: PropTypes.string,
};

CartPromoBadge.defaultProps = {
  title: '',
  text1: '',
  text2: '',
};

export default CartPromoBadge;
